module.exports = __webpack_public_path__ + "img/tile_01.d86e68c8.jpg";